import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoCalloutComponent } from './info-callout/info-callout.component';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoModule } from '@jsverse/transloco';

@NgModule({
  imports: [CommonModule, MarkantElementsModule, TranslocoModule],
  declarations: [InfoCalloutComponent],
  exports: [InfoCalloutComponent],
})
export class SharedUiInfoCalloutModule {}
